import React, { useState, useContext, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";

import api from '../../services/api';
import Swal from "sweetalert2";

export const ModalNotify = ({ isOpen, onAfterOpen, onRequestClose, loadPage }) => {
    var [idAtividade, setIdAtividade] = useState(null);

    const { timesheetItemAtividade, idTimesheetItemAtividade, timesheet } = useContext(TimeSheetDetalhesContext);
    var [descricao, setDescricao] = useState(null);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '25%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const handleDescricao = (valor) => {
        descricao = valor;
        setDescricao(descricao);
    }

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Notificação cadastrada com sucesso",
            icon: "success",
            timer: 2500,
            showConfirmButton: false,
        });
    };

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    };


    const formActivities = async () => {
        let payload = {
            IdTipoAtividadeNotificado: idAtividade,
            Mensagem: descricao?.target?.value,
            IdTimesheetItemAtividade: idTimesheetItemAtividade,
            referencia: timesheet?.pericia?.sigla ?? timesheet?.regulacao?.sigla
        }

        await api.post(`Timesheet/atividade/notificar`, payload)
            .then(async (response) => {
                onRequestClose(false);
                registrationSuccess();
                loadPage();
            })
            .catch((error) => {
                registrationFailure(error?.response?.data?.notification?.messageReturn)
            });
    }

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <Flex>
                <StyledForm style={{ width: "100%" }}>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Notificação de Atividade</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div style={{ width: '100%' }} className="position-relative form-group">
                                <textarea rows="3" className="input-form" placeholder='Mensagem' name='Mensagem' onBlur={handleDescricao} />
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group modal-align-center">
                                <input className='default-button-red' value='Notificar' onClick={formActivities} type="button" />
                            </div>
                        </Flex.Item>
                    </Flex>
                </StyledForm>
            </Flex>
        </Modal>
    );
};